import { useSearchLimits } from '../../hooks/useSearchLimits';

export function SearchesLeftBadge() {
  const { usage } = useSearchLimits();

  // Null only on first load before any count is known (cache keeps it stable after)
  if (!usage) return null;

  return (
    <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary/25 bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
      <span className="gold-dot" />
      <span>
        {usage.remainingSearches}{' '}
        <span className="hidden sm:inline">pulls left this month</span>
        <span className="sm:hidden">left</span>
      </span>
    </span>
  );
}
